import React, { Component } from 'react'
import {Helmet} from 'react-helmet'

import NavBar from '../components/NavBar';
import ContactForm from '../components/ContactForm'
import { Container, Col, Row, Image } from 'react-bootstrap';

export default class Contact extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC | Contact</title>
                </Helmet>
                <NavBar hasHero={false} />
                <Container>
                    <Row>
                        <Col>
                            <h1>Contact</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="2">
                            <a href="mailto:fkeller20@ssis.edu.vn"><Image className="contact-icon" alt="Email" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/icons%2Fmail.svg?alt=media&token=e1292d09-1016-44d3-b6f6-b3116ffdc97c" /></a>
                            <a href="https://www.facebook.com/ISSC.vn/" target="_blank" rel="noopener noreferrer"><Image className="contact-icon" alt="Facebook" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/icons%2Ffacebook.svg?alt=media&token=7ee446f8-ebe4-4105-b453-23acc1c5528c" /></a>
                            <a href="https://www.youtube.com/channel/UCs1whgMiPgcfHfS7qLdZwLQ"><Image className="contact-icon" alt="Youtube" src="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/icons%2Fyoutube.svg?alt=media&token=0b8c4e6f-5192-4352-a110-1f72cea0ab2d" /></a>
                        </Col>
                        <Col>
                            <h2>Send Us a Message</h2>
                            <ContactForm mailto="fkeller20@ssis.edu.vn" />
                        </Col>
                    </Row>
                </Container>
                <br />
                <br />
                <br />
                <br />
                <br />
            </div>
        )
    }
}
